<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-data-iterator
          :items="items"
          :loading="fetching"
          :items-per-page="items_per_page"
          :page.sync="current_page"
          :server-items-length="items_total"
          :single-expand="true"
          item-key="uuid"
        >
          <template v-slot:header>
            <v-card-actions>
              <form @submit.prevent="fetch">
                <v-text-field
                  label="Title"
                  solo
                  dense
                  flat
                  clearable
                  hide-details
                  prepend-inner-icon="mdi-magnify"
                  v-model="query"
                  @click:prepend-inner="fetch"
                  @click:clear="
                    () => {
                      query = null;
                      fetch();
                    }
                  "
                ></v-text-field>
              </form>
              <v-divider vertical></v-divider>
              <form @submit.prevent="fetch">
                <v-text-field
                  label="Author"
                  solo
                  dense
                  flat
                  clearable
                  hide-details
                  prepend-inner-icon="mdi-magnify"
                  v-model="author"
                  @click:prepend-inner="fetch"
                  @click:clear="
                    () => {
                      user = null;
                      fetch();
                    }
                  "
                ></v-text-field>
              </form>
              <v-divider vertical></v-divider>
              <v-select
                v-model="property_type"
                @change="fetch"
                solo
                dense
                flat
                hide-details
                :items="choices_property_type"
                item-text="text"
                item-value="value"
                label="Property Type"
              ></v-select>
              <v-divider vertical></v-divider>
              <v-select
                v-model="status"
                @change="fetch"
                solo
                dense
                flat
                hide-details
                :items="choices_status"
                item-text="text"
                item-value="value"
                label="Status"
              ></v-select>
              <v-divider vertical></v-divider>
              <v-select
                v-model="order_by"
                @change="fetch"
                solo
                dense
                flat
                hide-details
                :items="choices_order"
                item-text="text"
                item-value="value"
                label="Sort by"
              ></v-select>
              <v-divider vertical></v-divider>
              <v-btn
                icon
                depressed
                @click="
                  () => {
                    dir = dir == 'asc' ? 'desc' : 'asc';
                    fetch();
                  }
                "
              >
                <v-icon>{{ dir == 'asc' ? 'mdi-arrow-up' : 'mdi-arrow-down' }}</v-icon>
              </v-btn>
            </v-card-actions>
            <v-divider></v-divider>
            <v-progress-linear indeterminate :active="fetching" color="primary"></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <v-row align="center" justify="center">
              <div class="py-5">No data</div>
            </v-row>
          </template>
          <template v-slot:default="{ items, select, isSelected, expand, isExpanded }">
            <v-list>
              <template v-for="(item, index) in items">
                <property-item
                  @show="show"
                  v-bind="item"
                  @publish="publishProperty"
                  @unpublish="unpublishProperty"
                  @authorClick="(user) => {
                    author = user;
                    fetch();
                  }"
                  :key="index"
                />
                <v-divider :key="item.uuid"></v-divider>
              </template>
              <v-progress-linear indeterminate :active="fetching" color="primary"></v-progress-linear>
            </v-list>
          </template>
        </v-data-iterator>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { mapFields, mapMultiRowFields } from "vuex-map-fields";
import PorpertyItem from "../../components/property/PropertyItem";
export default {
  components: {
    "property-item": PorpertyItem
  },
  computed: {
    ...mapState("property", {
      fetching: "fetching",
      pagination: "pagination",
      instance: "instance",
      choices: "choices"
    }),

    ...mapGetters("property", {
      items: "items"
    }),
    ...mapFields("property", {
      query: "query.q",
      page: "query.page",
      order_by: "query.order_by",
      dir: "query.dir",
      author: "query.user",
      property_type: "query.property_type",
      status: "query.status"
    }),
    choices_order: function() {
      return this.choices.order;
    },
    choices_status: function() {
      return this.choices.status;
    },
    choices_property_type: function() {
      return this.choices.property_type;
    },
    items_per_page: function() {
      return _.get(this.pagination, "per_page", 15);
    },
    last_page: function() {
      return _.get(this.pagination, "last_page", 1);
    },
    current_page: {
      get: function() {
        return _.get(this.pagination, "current_page", 1);
      },
      set: function(page) {
        this.page = page;
        this.fetch();
      }
    },
    items_total: {
      get: function() {
        return _.get(this.pagination, "total", 0);
      },
      set: function(value) {
        return;
      }
    }
  },
  methods: {
    ...mapActions("property", {
      fetch: "fetch",
      publish: "publish",
      unpublish: "unpublish"
    }),
    show(uuid) {
      this.$router.push({ name: "property.show", params: { uuid } });
    },
    publishProperty(uuid) {
      this.publish(uuid).then(() => this.fetch());
    },
    unpublishProperty(uuid) {
      this.unpublish(uuid).then(() => this.fetch());
    }
  },

  mounted() {
    this.fetch();
  }
};
</script>

<style lang="scss" scoped></style>
